// src/pages/AboutElements.js
import styled from "styled-components";
import "@fontsource/lexend";
import "@fontsource/bebas-neue";
import "@fontsource/merriweather";

export const AboutPageContainer = styled.div`
  background: #282c34;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 16px;
`;

export const AboutCard = styled.article`
  width: 100%;
  max-width: 980px;
  background: #0f0f10;
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.45);
  overflow: hidden;
`;

export const AboutHeader = styled.header`
  background: radial-gradient(1200px 400px at 10% -10%,
    rgba(1,45,156,0.35),
    rgba(255,224,223,0.06) 60%,
    transparent),
    #121214;
  padding: 28px 26px 22px;
  border-bottom: 1px solid rgba(255,255,255,0.06);
`;

export const AboutTitle = styled.h1`
  margin: 0;
  font-family: "Merriweather";
  font-weight: 600;
  font-size: 28px;
  color: #fff;

  @media (max-width: 720px) {
    font-size: 22px;
  }
`;
export const AboutBody = styled.div`
  padding: 24px 26px 30px;
  display: flex;
  flex-direction: column;
  gap: 28px;
`;

export const Section = styled.section`
  background: #151517;
  border: 1px solid rgba(255,255,255,0.06);
  border-radius: 16px;
  padding: 18px 18px 20px;
`;

export const SectionTitle = styled.h2`
  margin: 0 0 10px 0;
  font-family: "Merriweather";
  font-weight: 600;
  color: #fff;
  font-size: 20px;
`;

export const P = styled.p`
  margin: 10px 0 0 0;
  color: #e6e6e6;
  font-family: "Lexend";
  font-size: 16px;
  line-height: 1.7;
  white-space: pre-line; /* keep your manual line breaks */
  text-align: justify;
`;

export const CTARow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, auto);
  gap: 10px;
  margin-top: 14px;

  @media (max-width: 520px) {
    grid-template-columns: 1fr;
  }
`;

export const CTAButton = styled.a`
  text-decoration: none;
  text-align: center;
  font-family: "Lexend";
  font-weight: 700;
  font-size: 14px;
  padding: 12px 14px;
  border-radius: 10px;
  background: #012D9C;
  color: #FFE0DF;
  box-shadow: 0 4px 14px rgba(1,45,156,0.35);
  transition: transform 0.08s ease, opacity 0.2s ease;
  &:hover { opacity: 0.95; }
  &:active { transform: translateY(1px) scale(0.99); }
`;

export const SecondaryButton = styled.a`
  text-decoration: none;
  text-align: center;
  font-family: "Lexend";
  font-weight: 700;
  font-size: 14px;
  padding: 12px 14px;
  border-radius: 10px;
  background: #181818;
  color: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.35);
  transition: transform 0.08s ease, opacity 0.2s ease;
  &:hover { opacity: 0.95; }
  &:active { transform: translateY(1px) scale(0.99); }
`;


export const PortraitBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px 0 0;
`;

export const PortraitImg = styled.img`
  display: block;
  width: 100%;
  max-width: 360px;          /* nice portrait width on desktop */
  height: auto;              /* keep aspect ratio */
  border-radius: 18px;
  box-shadow: 0 12px 28px rgba(0,0,0,0.45);
  background: #0f0f10;       /* fallback bg while loading */
  object-fit: cover;         /* in case the image is larger than the box */

  @media (max-width: 520px) {
    max-width: 70vw;         /* comfy margins on mobile */
    border-radius: 14px;
  }
`;